export const TelescopeTypes = {
    CONCAVE: 'concave',
    CONVEX: 'convex',
    FLATMIRROR: 'flatmirror',
    VIEWPOINT: 'viewpoint',
}
